export default __webpack_public_path__ + "static/media/top-k-2-med.a817e30b.jpg";